import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import ProtectedRoute from './ProtectedRoute';
import Login from '../modules/login';
import MainLayout from '../layouts/MainLayout';
import AuthLayout from '../layouts/AuthLayout';
import routes from './routes';
import { useProfile } from '../Contexts/ProfileContext';

type RootState = {
  user: {
    role: keyof typeof routes;
    token: string | null;
  };
};

function App() {
  const profile = useProfile();
  const { token } = useSelector((state: RootState) => state.user);

  // If user is not authenticated, show login routes
  if (!token) {
    return (
      <BrowserRouter>
        <Routes>
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    );
  }

  // If authenticated but profile not loaded yet, show loading
  if (!profile) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<div>Loading...</div>} />
        </Routes>
      </BrowserRouter>
    );
  }

  const role = profile.role;
  const layoutRoutes = role && routes[role] ? routes[role] : [];
  const allowedPaths = layoutRoutes.map((r) => r.path);

  return (
    <BrowserRouter>
      <Routes>
        {/* Protected routes */}
        <Route element={<MainLayout />}>
          {layoutRoutes.map(({ path, element, children }) => (
            <Route key={path} path={path} element={<ProtectedRoute allowedRoutes={allowedPaths}>{element}</ProtectedRoute>}>
              {children?.map((child: any) =>
                child.index ? (
                  <Route key="index" index element={child.element} />
                ) : (
                  <Route key={child.path} path={child.path} element={child.element} />
                ),
              )}
            </Route>
          ))}
          {/* Redirect unknown routes to first allowed route or login */}
          <Route path="*" element={<Navigate to={allowedPaths[0] || '/login'} replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
